<template>
    <div class="p-4">
        <ui-form-section class="mb-4">
            <ui-select-searchable
                class="col-span-12"
                label="Choose a Supplier"
                v-model="form.company_id"
                :error="form.errors.get('company_id')"
                :search="searchCompanies"
            ></ui-select-searchable>
        </ui-form-section>

        <div class="flex justify-end space-x-4">
            <ui-button-new @click="form.reset(); close()">Cancel</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">Create</ui-button-new>
        </div>
    </div>
</template>

<script>
import { MaterialSupplier, Company } from '@models'

export default {
    props: {
        material: Object,
        close: Function,
        addItem: Function,
        selectItem: Function,
    },
    data () {
        return {
            form: new Form({ material_id: this.material.id }, async (form) => {
                const materialSupplier = await MaterialSupplier.create(form.export())
                this.addItem(materialSupplier)
                this.selectItem(materialSupplier)

                form.reset()
                this.close()
            }),
        }
    },
    methods: {
        async searchCompanies (query) {
            return (await Company.search(query)).map(x => x.toDropdown())
        },
    },
}
</script>
